import { useTranslation } from "react-i18next";
import {Consts} from "../pages/consts";

const SessionTimeout = ({ onCloseDialog, showDialog }) => {
  const { t: t } = useTranslation();

  return (
    <div
      className="w3-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content w3-card-4 w3-animate-zoom form-panel dialog-narrow">
        <header className="w3-container w3-padding-small w3-center">
          <p>{t("session_timeout")}</p>
        </header>
        <div className="w3-container w3-padding-small w3-center">
          <label>{t("please_login_again")}.</label>
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={() => onCloseDialog()}
            >
              {t("close")}
            </button>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default SessionTimeout;
